export const PasswordRequirementText = () => (
  <p style={{ margin: 0, fontSize: "0.875rem", color: "#666" }}>
    Your new password must be at least 8 characters and include an uppercase
    letter, a lowercase letter and a special character.
  </p>
);
